import { render, staticRenderFns } from "./Novedad.vue?vue&type=template&id=6d8e3f6c&scoped=true&"
import script from "./Novedad.vue?vue&type=script&lang=js&"
export * from "./Novedad.vue?vue&type=script&lang=js&"
import style0 from "./Novedad.vue?vue&type=style&index=0&id=6d8e3f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e3f6c",
  null
  
)

export default component.exports